const EMAIL_PROVIDERS = {
  smtp: {
    label: "SMTP",
    icon: "/img/icons/smtp-com.webp",
    websiteUrl: "https://support.google.com/mail/answer/7126229",
    description:
      "Connect your custom SMTP server to send transactional emails from your website.",
    setupSteps: [
      "Choose your SMTP provider like Gmail, Zoho, Outlook, Hostinger, etc.",
      "Enable SMTP access from your email provider settings.",
      "If using Gmail, create an App Password.",
      "Copy SMTP Host, Port, Username and Password.",
      "Select proper encryption method (SSL/TLS).",
      "Enter sender email and sender name below.",
      "Save settings to activate email sending.",
    ],
    fields: [
      {
        name: "host",
        label: "SMTP Host",
        required: true,
        placeholder: "smtp.gmail.com",
        helperText:
          "Example: smtp.gmail.com, smtp.zoho.in, mail.yourdomain.com",
      },

      {
        name: "port",
        label: "SMTP Port",
        required: true,
        placeholder: "587",
        helperText: "Common ports: 465 (SSL), 587 (TLS)",
      },

      {
        name: "username",
        label: "SMTP Username",
        required: true,
        placeholder: "example@gmail.com",
        helperText: "Usually your email address.",
      },

      {
        name: "password",
        label: "SMTP Password",
        required: true,
        placeholder: "Enter SMTP Password",
        helperText: "Use App Password if provider supports 2FA.",
      },

      {
        name: "encryption",
        label: "Encryption",
        required: true,
        placeholder: "tls",
        helperText: "Supported values: ssl, tls",
      },

      {
        name: "fromEmail",
        label: "From Email",
        required: true,
        placeholder: "noreply@yourdomain.com",
        helperText: "Customer will receive emails from this address.",
      },

      {
        name: "fromName",
        label: "From Name",
        required: true,
        placeholder: "Your Store Name",
        helperText: "Sender name visible to customers.",
      },
    ],
  },

  mailchimp: {
    label: "Mailchimp",
    icon: "/img/icons/mailchimp.png",

    websiteUrl: "https://mailchimp.com",

    description:
      "Use Mailchimp for marketing campaigns, newsletters and customer email automation.",

    setupSteps: [
      "Create your Mailchimp account.",
      "Go to Account > Extras > API Keys.",
      "Generate a new API key.",
      "Create or select your Audience.",
      "Copy Audience ID from Audience Settings.",
      "Enter sender details below.",
      "Save settings to connect Mailchimp.",
    ],

    fields: [
      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "Enter Mailchimp API Key",
        helperText: "Available inside Mailchimp API Keys section.",
      },

      {
        name: "audienceId",
        label: "Audience ID",
        required: true,
        placeholder: "Enter Audience ID",
        helperText: "Available inside Audience Settings.",
      },

      {
        name: "fromEmail",
        label: "From Email",
        required: true,
        placeholder: "marketing@yourdomain.com",
        helperText: "Used for sending campaigns.",
      },

      {
        name: "fromName",
        label: "From Name",
        required: true,
        placeholder: "Your Brand Name",
        helperText: "Displayed as sender name.",
      },
    ],
  },

  resend: {
    label: "Resend",
    icon: "/img/icons/resend.jpg",

    websiteUrl: "https://resend.com",

    description:
      "Modern email API service for transactional emails and developer-friendly integrations.",

    setupSteps: [
      "Create account on Resend.",
      "Verify your sending domain.",
      "Go to API Keys section.",
      "Generate a new API key.",
      "Add sender email and sender name.",
      "Save settings to activate email delivery.",
    ],

    fields: [
      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "re_xxxxxxxxx",
        helperText: "Generate this from Resend dashboard.",
      },

      {
        name: "fromEmail",
        label: "From Email",
        required: true,
        placeholder: "noreply@yourdomain.com",
        helperText: "Must be verified inside Resend.",
      },

      {
        name: "fromName",
        label: "From Name",
        required: true,
        placeholder: "Your Store",
        helperText: "Displayed as sender name.",
      },
    ],
  },

  sendgrid: {
    label: "SendGrid",
    icon: "/img/icons/sengrid.png",

    websiteUrl: "https://sendgrid.com",

    description:
      "Cloud-based email delivery platform for transactional and marketing emails.",

    setupSteps: [
      "Create your SendGrid account.",
      "Verify sender identity or domain.",
      "Go to Settings > API Keys.",
      "Generate Full Access API Key.",
      "Copy API Key and add sender details.",
      "Save settings to activate integration.",
    ],

    fields: [
      {
        name: "apiKey",
        label: "API Key",
        required: true,
        placeholder: "SG.xxxxxxxxx",
        helperText: "Available inside SendGrid API Keys section.",
      },

      {
        name: "fromEmail",
        label: "From Email",
        required: true,
        placeholder: "support@yourdomain.com",
        helperText: "Must be verified in SendGrid.",
      },

      {
        name: "fromName",
        label: "From Name",
        required: true,
        placeholder: "Your Brand",
        helperText: "Visible to recipients.",
      },
    ],
  },
};

export default EMAIL_PROVIDERS;
